import { useMemo } from 'react'

import { getIntensityColor } from '@/components/exercises/Exercise/Muscles/Muscles.Utils'

import type { MuscleRegion } from './MuscleMap.Utils'

type Props = {
  muscleIntensity?: number
  region: MuscleRegion
  stretchIntensity?: number
}

export const Region = ({
  muscleIntensity = 0,
  region,
  stretchIntensity = 0,
}: Props) => {
  const color = useMemo(() => {
    const muscleIntensityColor = getIntensityColor('orange', muscleIntensity)
    const stretchIntensityColor = getIntensityColor('blue', stretchIntensity)

    if (muscleIntensity > 0 && stretchIntensity > 0) {
      return muscleIntensity >= stretchIntensity
        ? muscleIntensityColor
        : stretchIntensityColor
    } else {
      return muscleIntensity > 0 ? muscleIntensityColor : stretchIntensityColor
    }
  }, [muscleIntensity, stretchIntensity])

  if (color === 'transparent') {
    return null
  }

  return (
    <path d={region.d} fill={color} fillRule="evenodd">
      <title>{region.key.replace(/_/g, ' ')}</title>
    </path>
  )
}
